import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    fontFamily: "Proxima Nova Bold",
    fontSize: "1rem",
    margin: 0,
  },
});

interface NoteHeaderProps {
  seriesIndex: number;
  testIndexes: number[];
}

const NoteHeader = (props: NoteHeaderProps) => {
  const classes = useStyles();
  const { seriesIndex, testIndexes } = props;

  return (
    <p className={classes.root}>
      Note to test {seriesIndex}-{testIndexes ? testIndexes.join("/") : ""}
    </p>
  );
};

export default NoteHeader;
